module.exports = "/_next/static/images/img__message-e901ade60159612ac24f47e7c2474de1.png";